'use strict';

const Mn = require('backbone.marionette');
const OwnerListViewTemplate = require('system/ui/template/detail/owner-list.hbs');
const OwnerItemViewTemplate = require('system/ui/template/detail/owner-item.hbs');
const OwnerItemEditViewTemplate = require('system/ui/template/detail/owner-item-edit.hbs');

const OwnerItemView = Mn.View.extend({
    tagName: 'li',
    className: 'owner-list-item-flat',
    template: OwnerItemViewTemplate,
    events: {
        'click': 'toggle'
    },
    modelEvents: {
        'change': 'render'
    },

    templateContext: function() {
        return this.model.getUser().toJSON();
    },

    onRender: function() {
        if(this.model.get('deleted')) {
            this.destroy();
            return;
        }
        if(this.model.selected()) {
            this.activate();
        } else {
            this.deactivate();
        }
    },

    activate: function() {
        this.$el.addClass('is-active');
    },

    deactivate: function() {
        this.$el.removeClass('is-active');
    },

    toggle: function() {
        this.model.toggle();
    }
});

const OwnerItemEditView = OwnerItemView.extend({
    template: OwnerItemEditViewTemplate,
    events: {
        'click .remove': '_remove',
        'click': 'toggle'
    },

    _remove: function(evt) {
        this.triggerMethod('remove:owner', this.model);
        this.remove();
        evt.stopPropagation();
    }
});

module.exports = Mn.CompositeView.extend({
    template: OwnerListViewTemplate,
    childViewContainer: '.owner-list',
    childView: function() {
        if(this.edit) {
            return OwnerItemEditView;
        } else {
            return OwnerItemView;
        }
    },

    initialize: function(params) {
        this.edit = params.edit;
        this._context = params.context;
        this.listenTo(this.getOption('members'), 'change', this.render);
    },

    onChildviewRemoveOwner: function(owner) {
        this.trigger('remove:owner', owner);
    }
});




// WEBPACK FOOTER //
// ./system/ui/view/detail/owner-list.js